import React from 'react'
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { Link } from 'react-router-dom';

function AssetDataBase() {
    return (
        <ul className="AssetDataBase">
            <li><h1>Birth of the Thousand Blooms</h1></li>
            <li>Current Owner: <br/><Link to="/user/username">@jonsmith</Link></li>
            <li>Minted on: <br/><span className="AssetPRightInfo">Sun, 25 Apr 2021 11:30:54 GMT</span></li>
            <li>Mint Number: <br/><span className="AssetPRightInfo">7 out of 25</span></li>
            <li>Last Sale: <br/><span className="AssetPRightInfo">24 days ago for 16 KCAL • ¥65.60</span></li>
            <li>Listing starts on: <br/><span className="AssetPRightInfo">Thu, 01 Jul 2021 03:34:21 GMT in 34 days, 10 hours, 18 minutes</span></li>
            <li>Favorites: <span className="AssetPRightInfo"><FavoriteBorderIcon /></span></li>
        </ul>
    )
}

export default AssetDataBase

